var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42932 16.7637V10.497L0.953125 6.47796L4.47693 0.763672H11.5246L15.0484 6.47796L12.5722 10.497V16.7637L8.00074 15.2399L3.42932 16.7637ZM4.95312 14.6494L8.00074 13.6399L11.0484 14.6494V12.1922H4.95312V14.6494ZM5.33408 2.28748L2.7436 6.47796L5.33408 10.6684H10.6674L13.2579 6.47796L10.6674 2.28748H5.33408ZM7.20074 9.58272L4.49598 6.89701L5.5817 5.81129L7.20074 7.43034L10.4198 4.19224L11.5055 5.25891L7.20074 9.58272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteVector);
export default __webpack_public_path__ + "static/media/CompleteVector.283460e77027851e234639aab13b9a5c.svg";
export { ForwardRef as ReactComponent };